import React, { useCallback, useEffect, useState } from "react";
import "./ClubReviewThankYou.css";
import verifyLogo from "../../Payment-successful/image/verified-logo.png"
import logoImg from "../img/logo-in-review.svg"
import logoImgRef from "../img/review-imag.svg"
import { RiUserAddLine } from "react-icons/ri";
import { IoBagOutline } from "react-icons/io5";
import { FaPercent } from "react-icons/fa";
import Loginpopup from "../../Navbar/Loginmodal";
import InviteFriendModal from "./InviteFriendModal";
import { useSearchParams } from "react-router-dom";

export default function ClubReviewThankYou() {

    const [searchParams] = useSearchParams();
    const reviewSubmittedCode = searchParams.get("code");


    const userdata = JSON.parse(localStorage.getItem("userData"));

    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [showModalPopup, setShowModalPopup] = useState(false);

    const handleLogin = useCallback((ud) => {
        if (ud) {
            localStorage.setItem("userData", JSON.stringify(ud));
            window.location.reload();
            setShowLoginPopup(false);
        }
    }, []);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (!userData) {
            setShowLoginPopup(true);
        }
    }, []);


    return (
        <>
            {showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />}
            <div className="pw-container">

                {/* Review Section */}
                <div className="pw-review-card">
                    <div className="pw-check-icon"><span className="pw-verify-logo"><img src={verifyLogo} alt="verify-logo" /></span></div>
                    <h2>Thanks For Your Review, {userdata?.name.split(" ")[0]}!</h2>
                    <p>Your feedback helps other party planners — and us — get even better.</p>
                </div>

                {/* Discount Section */}
                <div className="pw-discount-card">
                    <p>As a token of our appreciation, here’s a special discount for your next PartyWitty booking.</p>
                    {reviewSubmittedCode && <span className="pw-discount-code">{reviewSubmittedCode}</span>}
                    {/* <span className="pw-discount-code">{reviewSubmittedCode.code}</span> */}
                </div>

                {/* Coming Soon Section */}
                <div className="pw-coming-soon">
                    <div className="pw-image-strip">
                        <div className="pw-blurred-img"></div>
                        <div className="pw-blurred-img"></div>
                        <div className="pw-blurred-img"></div>
                        <div className="pw-blurred-img"></div>
                    </div>
                    <div className="pw-coming-text">Coming Soon</div>
                </div>

                {/* Refer & Earn */}
                <div className="pw-refer-card" style={{ backgroundImage: `url(${logoImg})`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "top" }}>
                    <h3>Refer & Earn</h3>
                    <p>
                        Share the party vibes with your friends and collect carrots every time they join in.
                        More carrots = more savings on your next night out!
                    </p>
                    <button onClick={() => setShowModalPopup(true)} className="pw-invite-btn"><RiUserAddLine /> Invite Friends</button>

                    <div className="pw-how-it-works-container" >
                        <div className="pw-how-it-works">
                            <h4>How it works</h4>
                            <div className="pw-bonus">
                                <span className="pw-icon"><IoBagOutline /></span>
                                <p className="pw-icon-b-dis"><strong className="pw-b-title">Referral Bonus</strong><br />Earn 200 Carrots for every friend who signs up and makes their first booking.</p>
                            </div>
                            <div className="pw-bonus">
                                <span className="pw-icon"><FaPercent /></span>
                                <p className="pw-icon-b-dis"><strong className="pw-b-title">Friend's Discount</strong><br />Your friends get 100 Carrots on their first booking when they use your referral code.</p>
                            </div>
                        </div>
                        <div>
                            <img src={logoImgRef} alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <InviteFriendModal isOpen={showModalPopup} onClose={() => setShowModalPopup(false)} />
        </>
    );
}
